// Displays the header and instructions for the contact form
import React from 'react';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { contactFormCopy } from '@/contexts/language/translations/pages/contactForm';

// Props for the ContactFormHeader component
interface ContactFormHeaderProps {
  service: string; // The service the user is inquiring about
}

const ContactFormHeader: React.FC<ContactFormHeaderProps> = ({ service }) => {
  const { language } = useLanguage();
  const c = contactFormCopy[language];
  
  return (
    <div className="mb-8 text-center">
      {/* Title */}
      <h3 className="text-3xl md:text-4xl font-bold mb-2 text-gray-900">{c.heading}</h3>
    </div>
  );
};

export default ContactFormHeader;
